import { createFileRoute } from '@tanstack/react-router';
import { lockRouteBeforeLoad } from '@/lib/auth/resolveLockRedirect';
import { SetupPendingPage } from '@/pages/initial-setup/SetupPendingPage';

export const Route = createFileRoute('/$slug/setup-pending')({
  component: SetupPendingPage,
  beforeLoad: lockRouteBeforeLoad('/$slug/setup-pending')
});
